import React from "react";
import ResetPassword from "../components/ResetPassword/ResetPassword";

function ResetPasswordPage() {
  return <ResetPassword />;
}

export default ResetPasswordPage;
